import { Card, Typography, Chip, Stack, Button, Collapse } from "@mui/material";
import { Box } from "@mui/system";
import {
  colors,
  spacing,
  typography,
} from "../../../../../../../../../assets/styles/tokens";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import React from "react";
import BudgetControlCardItemMoreMetrics from "./BudgetControlCardItemMoreMetrics";
import BudgetControlCardItemLastRun from "./BudgetControlCardItemLastRun";

// ─────────────────────────────────────────────────────────────────────────────

//type StatusColor = "success" | "error";

interface BudgetControlCardItemViewProps {
  website_name: string;
  website_id: string;

  qftd: string;
  qftds: string;
  qftd_status: string;
  qftd_percentage: string;
  budget_dollar: string;
  budgets_dollar: string;
  budget_status: string;
  budget_percentage: string;
  rr_budget_status: string;
  rr_budget_percentage: string;
  remaining_qftd: string;
  cpa_income_dollar: string;
  total_income_dollar: string;
  cpa_budget_dollar: string;
  ftd: string;

  runDate: string;
  runRange: string;
  runBy: string;
  status: string;
}

export function BudgetControlCardItemView({
  website_name,
  website_id,
  qftd,
  qftds,
  qftd_status,
  qftd_percentage,
  budget_dollar,
  budgets_dollar,
  budget_status,
  budget_percentage,
  rr_budget_status,
  rr_budget_percentage,
  remaining_qftd,
  cpa_income_dollar,
  total_income_dollar,
  cpa_budget_dollar,
  ftd,
  runDate,
  runRange,
  runBy,
  status,
}: BudgetControlCardItemViewProps) {
  const [open, setOpen] = React.useState(false);
  return (
    <>
      <Card
        sx={{
          p: 1,
          borderRadius: spacing.Radius.lg.$value,
          boxShadow: "0px 1px 2px #0A0D120F , 0px 1px 3px #0A0D121A",
          border: "1px solid" + colors.GrayLightMode[200].$value,
          mb: spacing.Spacing.none.$value,
          mt: spacing.Spacing.xl.$value + "!important",
        }}
      >
        {/* Top Row */}
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography
            variant="body1"
            sx={{
              color: colors.GrayLightMode[700].$value,
              fontSize: typography.Size.Text.xs.$value,
              fontWeight: typography.Font_weight.Medium.$value,
            }}
          >
            {website_name} ({website_id})
          </Typography>
          <BudgetControlCardItemLastRun
            title={website_name}
            brandId={website_id}
            runDate={runDate}
            runRange={runRange}
            runBy={runBy}
            status={status}
          />
        </Stack>

        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mt={spacing.Spacing.md.$value}
          mb={spacing.Spacing.xs.$value}
        >
          <Box display="flex" alignItems="center">
            <Typography
              variant="body2"
              sx={{
                color: colors.GrayLightMode[900].$value,
                fontWeight: typography.Font_weight.Bold.$value,
                mr: spacing.Spacing.xs.$value,
              }}
            >
              {qftd}/{qftds}
            </Typography>

            <Typography
              variant="body2"
              sx={{
                color: colors.GrayLightMode[900].$value,
                mr: spacing.Spacing.xs.$value,
              }}
            >
              Budgeted QFTD’s
            </Typography>
          </Box>

          <Box>
            <Chip
              label={qftd_percentage}
              size="small"
              sx={{
                borderRadius: spacing.Radius.xs.$value,
                fontSize: typography.Size.Text.sm.$value,
                bgcolor:
                  qftd_status === "success"
                    ? colors.Success[50].$value
                    : qftd_status === "warning"
                      ? colors.Warning[50].$value
                      : colors.Error[50].$value,

                color:
                  qftd_status === "success"
                    ? colors.Success[600].$value
                    : qftd_status === "warning"
                      ? colors.Warning[600].$value
                      : colors.Error[600].$value,

                fontWeight: typography.Font_weight.Semibold.$value,
              }}
            />
          </Box>
        </Stack>

        <Stack
          direction="row"
          alignItems="center"
          mt={spacing.Spacing.sm.$value}
          mb={spacing.Spacing.sm.$value}
        >
          <Box>
            <Chip
              label={budget_percentage}
              size="small"
              sx={{
                borderRadius: spacing.Radius.xs.$value,
                fontSize: typography.Size.Text.sm.$value,
                mr: spacing.Spacing.sm.$value,
                bgcolor:
                  budget_status === "success"
                    ? colors.Success[50].$value
                    : budget_status === "warning"
                      ? colors.Warning[50].$value
                      : colors.Error[50].$value,

                color:
                  budget_status === "success"
                    ? colors.Success[600].$value
                    : budget_status === "warning"
                      ? colors.Warning[600].$value
                      : colors.Error[600].$value,

                fontWeight: typography.Font_weight.Semibold.$value,
              }}
            />
          </Box>
          <Box display="flex" alignItems="center">
            <Typography
              variant="body2"
              sx={{
                color: colors.GrayLightMode[900].$value,
                mr: spacing.Spacing.xs.$value,
              }}
            >
              of budget used
            </Typography>

            <Typography
              variant="body2"
              sx={{
                color: colors.GrayLightMode[900].$value,
                fontWeight: typography.Font_weight.Bold.$value,
              }}
            >
              ({budget_dollar} / {budgets_dollar})
            </Typography>
          </Box>
        </Stack>

        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
        >
          <Box display="flex" alignItems="center">
            <Typography
              variant="body2"
              sx={{
                color: colors.GrayLightMode[900].$value,
              }}
            >
              RR BUDGET USED
            </Typography>

            <Chip
              label={rr_budget_percentage}
              size="small"
              sx={{
                borderRadius: spacing.Radius.xs.$value,
                fontSize: typography.Size.Text.sm.$value,
                ml: spacing.Spacing.sm.$value,
                bgcolor:
                  rr_budget_status === "success"
                    ? colors.Success[50].$value
                    : rr_budget_status === "warning"
                      ? colors.Warning[50].$value
                      : colors.Error[50].$value,

                color:
                  rr_budget_status === "success"
                    ? colors.Success[600].$value
                    : rr_budget_status === "warning"
                      ? colors.Warning[600].$value
                      : colors.Error[600].$value,

                fontWeight: typography.Font_weight.Semibold.$value,
              }}
            />
          </Box>
          <Button
            size="small"
            onClick={() => setOpen(!open)}
            sx={{
              padding: "0",
              fontSize: typography.Size.Text.xs.$value,
              lineHeight: typography.Line_height.text.xs.$value,
              color: colors.Brand[800].$value,
              fontWeight: typography.Font_weight.Regular.$value,
              textTransform: "capitalize",
              letterSpacing: "0px",
            }}
            data-tracker="654"
          >
            {open ? "Less More Metrics" : "Show More Metrics"}
            <ExpandMoreIcon
              sx={{
                color: colors.Brand[800].$value,
                transform: open ? "rotate(180deg)" : "rotate(0deg)",
                transition: "0.2s",
              }}
            />
          </Button>
        </Stack>
        <Stack>
          {/* Expandable Info */}
          <Collapse in={open}>
            <BudgetControlCardItemMoreMetrics
              remaining_qftd={remaining_qftd}
              cpa_income_dollar={cpa_income_dollar}
              total_income_dollar={total_income_dollar}
              cpa_budget_dollar={cpa_budget_dollar}
              ftd={ftd}
            />
          </Collapse>
        </Stack>
      </Card>
    </>
  );
}
export default BudgetControlCardItemView;
